import { z } from 'zod';
import { defineForm } from '../registry.js';
import { CONFIRMERS, idString, longtext } from './common.js';

// 第5表（居宅介護支援経過）。旧: EventRecord（1 件 = 1 つの経過の記載）。
// 本文の上限は旧 API に無い（エージェントは 2000）。ここは API 側に合わせ上限なし。
// 削除（deletedAt/deletedBy）は状態の列で扱うので本文に入れない

export const supportProgressSchema = z
  .object({
    occurredAt: z.string().min(1).meta({ kind: 'date' }).describe('年月日'),
    body: longtext('内容').min(1),
    evidenceEventIds: z.array(idString).max(20).optional().describe('根拠の記録ID'),
    evidenceFacilityNoteIds: z.array(idString).optional().describe('根拠の施設記録ID'),
  })
  .strict();
export type SupportProgressBody = z.infer<typeof supportProgressSchema>;

export const supportProgressForm = defineForm({
  app: 'caremanager',
  docType: 'support_progress',
  name: '居宅介護支援経過（第5表）',
  version: 1,
  schema: supportProgressSchema,
  confirmers: CONFIRMERS,
  description: '支援の経過を 1 件ずつ記載する',
});
